"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Organization_1 = __importDefault(require("../entity/Organization"));
class OrganizationStub extends Organization_1.default {
    constructor({ id = '123', name = 'Kaizen Platform' } = {}) {
        super({ id, name });
    }
}
exports.default = OrganizationStub;
